import React from 'react';
import { components } from 'react-select';
import type { SingleValueProps } from 'react-select';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

// constants
import { SearchableSelectType } from './searchableSelect';

// import AampeTooltip from '../shared/AampeTooltip/AampeTooltip';

// TODO: Add AampeTooltip component

interface SingleValueCompactProps
    extends SingleValueProps<SearchableSelectType> {
    title?: string;
}
const SingleValueCompact: React.FC<SingleValueCompactProps> = (props) => {
    const { title } = props;
    return (
        <components.SingleValue {...props}>
            <Label>
                {title && <LabelText>{title}:</LabelText>}
                {props.data.trailingIcon ? (
                    <LabelIcon title={'test'}>
                        {props.data.trailingIcon}
                    </LabelIcon>
                ) : (
                    <LabelText>{props.data.label}</LabelText>
                )}
            </Label>
        </components.SingleValue>
    );
};

const Label = styled.div(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
}));

const LabelText = styled.div({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

const LabelIcon = styled.div({
    display: 'flex',
    alignItems: 'center',
});

export default SingleValueCompact;
